import React from 'react'

import { Grid, Rating, Typography } from '@mui/material'

import { RatingOptions } from '../../app/launchDarkly/types';
import { FilledStarLargeIcon, UnfilledStarLargeIcon } from '../../utils/iconRefs/recipeRatingIcons';
import { RATING_OPTIONS } from './CookingHistoryEdit';
import styles from "./RecipeRatingEdit.module.css";

const RecipeRatingEdit = ({ rating, setRating, ratingOptions, defaultRecipeImage, disabledEditing }: {
    rating: number,
    setRating: React.Dispatch<React.SetStateAction<number>>,
    ratingOptions: RatingOptions,
    defaultRecipeImage: string,
    disabledEditing: boolean,
}) => (
    <Grid className={styles.mainContainer}>
        <Grid className={styles.imageContainer}>
            <Grid className={styles.ratings} item xs={12}>
                <Typography variant="h6">Your rating</Typography>
                <Rating
                    disabled={disabledEditing}
                    emptyIcon={<UnfilledStarLargeIcon />}
                    icon={<FilledStarLargeIcon />}
                    name="recipe-rating"
                    onChange={(event, newValue) => { setRating(newValue ?? 0) }}
                    value={rating}
                />
            </Grid>
            <Grid className={styles.image}>
                <img
                    alt="Default Recipe"
                    className={styles.image}
                    src={defaultRecipeImage}
                />
            </Grid>
        </Grid>
        <Grid className={styles.ratingsContainer}>
            <Grid item xs={12}>
                {!rating ?
                    <Typography color="#9797AA" variant="caption4Light">
                        Help us make your cooking experience better
                    </Typography> :
                    <Typography variant="caption4Light">
                        {ratingOptions[RATING_OPTIONS[rating]]?.title}
                    </Typography>
                }
            </Grid>
        </Grid>
    </Grid>
);

export default RecipeRatingEdit;